export { default } from './footer-service';
